module.exports = "img/flags/LC.5f0dc5a.png";